import * as React from 'react';
import {Button, Modal} from 'antd';
import FormWrapper, {FormStates} from './FormWrapper';
import {gaUploadMaterialClicked, gaWriteFeedbackClicked} from '../../ga/course';

interface IProps {
  buttonText: string;
  formComponent: any;
}

interface IState {
  isVisible: boolean; // is modal visible
  formState: FormStates; // state of the form inside modal
  formMessage: string;
}

export default class FormModal extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      isVisible: false,
      formState: FormStates.active,
      formMessage: ''
    }
  }

  showModal = () => {
    this.sendGaEvent(this.props.buttonText);
    this.setState(() => ({isVisible: true, formState: FormStates.active}));
  };

  closeModal = () => {
    this.setState(() => ({isVisible: false, formState: FormStates.active}));
  };

  handleFormStateChange = (formState: FormStates, formMessage: string) => {
    this.setState({formState, formMessage});
  }

  public render() {
    const {buttonText, formComponent} = this.props;

    return(
      <div>
        <Button type='default' onClick={this.showModal}>{buttonText}</Button>
        <Modal
          width={640}
          title={buttonText}
          footer={null}
          onCancel={this.closeModal}
          visible={this.state.isVisible} >
          <FormWrapper formState={this.state.formState}
                       formMessage={this.state.formMessage}
                       successAction={this.closeModal}
                       errorAction={this.showModal} >

            {React.cloneElement(formComponent, {onFormStateChange: this.handleFormStateChange})}

          </FormWrapper>


        </Modal>
      </div>
    )
  }

  sendGaEvent = (buttonText: string) => {
    switch (buttonText) {
      case 'Write Feedback':
        gaWriteFeedbackClicked();
        break;
      case 'Upload Material':
        gaUploadMaterialClicked();
        break;
      default:
        return;
    }
  }

}